/**
 * Stato della simulazione ruolo, leggibile fuori da React.
 *
 * L'istanza axios e' un singleton di modulo e non puo' usare gli hook:
 * SimulazioneContext tiene sincronizzato questo oggetto, l'interceptor lo
 * legge. Unico scrittore il contesto, unico lettore l'interceptor.
 */

export interface StatoSimulazione {
  attiva: boolean
  /** Etichetta leggibile del ruolo simulato, per i messaggi all'utente */
  ruolo: string | null
}

let stato: StatoSimulazione = { attiva: false, ruolo: null }

export const impostaStatoSimulazione = (nuovo: StatoSimulazione): void => {
  stato = nuovo
}

export const leggiStatoSimulazione = (): StatoSimulazione => stato

/**
 * Spegne la simulazione subito, senza passare da React.
 *
 * Serve sui percorsi di uscita dall'account: il contesto la sincronizza con un
 * useEffect, che gira dopo il render, mentre qui serve che l'interceptor veda
 * lo stato gia' spento alla richiesta successiva. Chiamarla non sostituisce
 * `esci()` del contesto — le due si usano insieme, questa per l'immediatezza,
 * quella per riportare l'interfaccia a se stessa.
 */
export const azzeraStatoSimulazione = (): void => {
  stato = { attiva: false, ruolo: null }
}
